import { useState } from "react";

import { Grid, TextField } from "@mui/material";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { FormHiddenField, IconAutocomplete } from "../../../../components/forms";
import { DRAWER_FORM_GRID_SPACING, drawerReadonlyFieldSx } from "../../../../lib/ui/dialogFormLayout";
import { COMMENT_TYPE_OPTIONS } from "../../../../lib/ui/iconSelectOptions";
import { useTranslation } from "react-i18next";

const CommentIncidentBody = (item: any) => {
  const { t } = useTranslation();
  const [selectedCommentType, setSelectedCommentType] = useState<string | null>("UPDATE");

  return (
    <DrawerForm>
      <DrawerFormSection title={t("form.incident")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              fullWidth
              id="incidentId"
              name="incidentId"
              label={t("common.id")}
              variant="outlined"
              size="small"
              value={item?.id || ""}
              InputProps={{ readOnly: true }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              id="incidentTitle"
              name="incidentTitle"
              label={t("common.title")}
              variant="outlined"
              size="small"
              value={item?.title || ""}
              InputProps={{ readOnly: true }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>

      <DrawerFormSection title={t("form.comment")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <IconAutocomplete
              options={COMMENT_TYPE_OPTIONS}
              value={selectedCommentType}
              onChange={setSelectedCommentType}
              label={t("common.type")}
              noOptionsText="No comment type options found"
            />
            <FormHiddenField name="type" value={selectedCommentType || ""} />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              fullWidth
              id="comment"
              name="comment"
              label={t("incidents.comment")}
              variant="outlined"
              size="small"
              multiline
              rows={4}
              placeholder={t("form.writeComment")}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default CommentIncidentBody;
